// extracted by mini-css-extract-plugin
export var stepActive = "_2v-3";
export var stepCompleted = "_2v-4";
export var stepConnectorLine = "_2v-b";
export var stepIndicatorCircle = "_2v-6";
export var stepIndicatorCircleCompleted = "_2v-7";
export var stepIndicatorCircleDefault = "_2v-8";
export var stepIndicatorTextCompleted = "_2v-9";
export var stepIndicatorTextDefault = "_2v-a";
export var stepPending = "_2v-5";
export var wizardContainer = "_2v-1";
export var wizardContent = "_2v-2";
export var wizardModal = "_2v-0";